import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { emptyArray } from 'ui-components/default-props/empty';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { LockIconWithTooltip } from '../../feature-gates/lock-icon-with-tooltip';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import styles from './action-item.module.less';

const PrintDocumentActionMenuItem = ({ data = emptyArray, disabled = false, name, onClick, isFeatureEnabled = true, ...props }) => {
  const onClickHandler = useCallback(() => {
    onClick(data, false);
  }, [data, onClick]);

  return (
    <DropdownMenuItem
      {...props}
      className={{
        [styles['unassigned-action-item']]: !disabled,
        [styles['is-locked']]: !isFeatureEnabled,
      }}
      disabled={disabled}
      onClick={onClickHandler}
    >
      <FormattedMessage {...name} />
      {!isFeatureEnabled && <LockIconWithTooltip iconClass={styles['lock-icon']} />}
    </DropdownMenuItem>
  );
};

PrintDocumentActionMenuItem.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  name: MessageDescriptorPropType.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PrintDocumentActionMenuItem;
